import React, { useEffect, useState, useCallback } from 'react';
import { Box } from '@mui/material';
import Industry from './Common/Industry';
import Insurance from './Common/Insurance';
import NextGen from './Common/NextGen';
import MonthlyTurnoverBCM from './BCMCards/MonthlyTurnoverBCM';
import SubIndustryBCM from './BCMCards/SubIndustryBCM';
import MonthlyTurnoverFMCG from './FMCGCards/MonthlyTurnoverFMCG';
import SubIndustryFMCG from './FMCGCards/SubIndustryFMCG';
import RefrigeratedUnits from './FMCGCards/RefrigeratedUnits';
import StoreType from './FMCGCards/StoreType';
import BrandCount from './FMCGCards/BrandCount';
import { SendProfilerAction, UpdateProfilerAction, getModulerProfilerAction, getProfilerAction } from '../API/Action';
import { MaritalStatusEnum } from '../config/Profiler_enum';
import MaritalStatus from './PersonalCards/MaritalStatus';
import Anniversary from './PersonalCards/Anniversary';
import SpouseHelps from './PersonalCards/SpouseHelps';
import KidsTabCard from './PersonalCards/KidsTabCard';
import RecreationalType from './PersonalCards/RecreationalType';
import RecreationalDomestic from './PersonalCards/RecreationalDomestic';
import RecreationalForeign from './PersonalCards/RecreationalForeign';
import { toast } from 'react-toastify';
import { ProfilerQuestionID } from '../config/QuestionEnum';
import PrefferedLanguage from './PersonalCards/PrefferedLanguage';
import { getLanguagesAction } from '../API/Action';
import BCMBrandSteel from './BCMCards/BCMBrandSteel';
import BCMBrandCement from './BCMCards/BCMBrandCement';
import BCMBrandPaintAndHardware from './BCMCards/BCMBrandPaintAndHardware';
import BCMBrandPlumbingPipeAndWaterTank from './BCMCards/BCMBrandPlumbingPipeAndWaterTank';
import BCMBrandTilesAndAdhesive from './BCMCards/BCMBrandTilesAndAdhesive';
import BCMBrandPlywood from './BCMCards/BCMBrandPlywood';
import BCMBrandElectricalsSuppliers from './BCMCards/BCMBrandElectricalsSuppliers';


const QUESTION_CONFIG = [
    { id: ProfilerQuestionID.INDUSTRY, component: Industry },
    // FMCG FLOW 
    { id: ProfilerQuestionID.FMCG_SUB_INDUSTRY, component: SubIndustryFMCG },
    { id: ProfilerQuestionID.FMCG_BRAND_NUMBERS, component: BrandCount },
    { id: ProfilerQuestionID.FMCG_TURNOVER, component: MonthlyTurnoverFMCG },
    { id: ProfilerQuestionID.FMCG_STORE_TYPE, component: StoreType },
    { id: ProfilerQuestionID.FMCG_FROZEN_FOODS, component: RefrigeratedUnits },
    // BCM FLOW 
    { id: ProfilerQuestionID.BCM_SUB_INDUSTRY, component: SubIndustryBCM },
    
    { id: ProfilerQuestionID.BCM_CEMENT_BRANDS, component: BCMBrandCement },
    { id: ProfilerQuestionID.BCM_STEEL_BRANDS, component: BCMBrandSteel },
    { id: ProfilerQuestionID.BCM_PAINT_AND_HARDWARE_BRANDS, component: BCMBrandPaintAndHardware },
    { id: ProfilerQuestionID.BCM_PLUMBING_PIPE_AND_WATER_TANK_BRANDS, component: BCMBrandPlumbingPipeAndWaterTank },
    { id: ProfilerQuestionID.BCM_TILES_AND_ADHESIVE_BRANDS, component: BCMBrandTilesAndAdhesive },
    { id: ProfilerQuestionID.BCM_PLYWOOD_BRANDS, component: BCMBrandPlywood },
    { id: ProfilerQuestionID.BCM_ELECTRICALS_SUPPLIERS_BRANDS, component: BCMBrandElectricalsSuppliers },
    
    { id: ProfilerQuestionID.BCM_TURNOVER, component: MonthlyTurnoverBCM },

    { id: ProfilerQuestionID.NEXT_GEN, component: NextGen },
    { id: ProfilerQuestionID.INSURANCE_INTEREST, component: Insurance },
  
    { id: ProfilerQuestionID.MARITAL_STATUS, component: MaritalStatus },
    { id: ProfilerQuestionID.MARRIAGE_ANNIVERSARY, component: Anniversary },
    { id: ProfilerQuestionID.SPOUSE_BUSINESS_INVOLVEMENT, component: SpouseHelps },

    // Recreation and Kids (Personal)
    { id: ProfilerQuestionID.PREFERRED_HOLIDAY_DESTINATION, component: RecreationalType },
    { id: ProfilerQuestionID.PREFERRED_DOMESTIC_DESTINATION, component: RecreationalDomestic },
    { id: ProfilerQuestionID.PREFERRED_INTERNATIONAL_DESTINATION, component: RecreationalForeign },

    { id: ProfilerQuestionID.PREFERRED_LANGUAGE, component: PrefferedLanguage },

    { id: ProfilerQuestionID.KIDS_COUNT , component: KidsTabCard },
    { id:ProfilerQuestionID.KIDS_EDUCATION_COUNT , component: KidsTabCard },
];
const ProfilerCards = ({ initialProfiler, module='home', onQuestionsChange }) => {
  const [profilerData, setProfilerData] = useState(initialProfiler?.questions || null);
  const [loading, setLoading] = useState(false);
  const [updateFlag, setUpdateFlag] = useState(initialProfiler?.is_profile_exist || false);
  const [languageOptions, setLanguageOptions] = useState({ preferred: [], others: [] });

  useEffect(() => {
    onQuestionsChange?.(profilerData);
  }, [profilerData, onQuestionsChange]);

  useEffect(() => {
    // Fetch only once on mount
    getLanguagesAction().then(({ data, error }) => {
      if (!error && data) {
        setLanguageOptions({
          preferred: Array.isArray(data.preferred) ? data.preferred : [],
          others: Array.isArray(data.others) ? data.others : [],
        });
      }
    });
  }, []);
  const fetchProfilerData = useCallback(async () => {
    setLoading(true);
    const { error, data, messsage } = await getModulerProfilerAction(module);
    setLoading(false);
    if(!error){
      setProfilerData(data?.questions);
      setUpdateFlag(data?.is_profile_exist);
    }else{
      setProfilerData(null);
      setUpdateFlag(null);
    }
  }, []);
  useEffect(() => {
    if(!initialProfiler){
      fetchProfilerData();
    }
  }, [initialProfiler]);
  const handleSubmit = async (payload) => {
    setLoading(true);
    const { error, data, message } = await SendProfilerAction(payload);
    setLoading(false);
    if(error){
      toast.error(message);
    }else{
      await fetchProfilerData();
    }
  };
  let ids = Array.isArray(profilerData)
    ? profilerData.map((item) => item.id)
    : null;

  const cards = (ids || [])
    .map((id, idx, arr) => {
      const config = QUESTION_CONFIG.find(q => q.id === id);
      if (!config) return null;
      const question = profilerData.find(item => item.id === id);
      const commonProps = {
        questionId: id,
        onSubmit: handleSubmit,
        ...(question?.title ? { title: question.title } : {}),
        ...(question?.value != null ? { value: question.value } : {}),
        ...(question?.suggestions ? { suggestions: question.suggestions } : {}),
      };
      if (id === ProfilerQuestionID.PREFERRED_LANGUAGE) {
        return <config.component key={id} {...commonProps} options={languageOptions} />;
      }
      return <config.component key={id} {...commonProps} />;
    })
    .filter(Boolean);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: { xs: 'flex-start' },
        pr: { xs: 2, md: 0 },
        gap: 2,
        opacity: loading ? 0.5 : 1,
        pointerEvents: loading ? 'none' : 'auto',
        overflowX: 'scroll',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      {cards}
    </Box>
  );
};

export default ProfilerCards;
